<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.paciente"
            ref="DataTable"
            search-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="open(item)"
                    authorize="update-farmacia-estorno-dispensacao"
                    color="primary"
                    small
                    title="Dispensações"
                >
                    <rkm-icon icon="hand-holding" />
                </rkm-button>
            </template>

            <template v-slot:cell(dataNascimento)="row">
                {{ row.value | formatDate }}
            </template>

            <template v-slot:cell(cpf)="row">
                {{ row.value | formatCpf }}
            </template>

            <template v-slot:cell(cns)="row">
                {{ row.value | formatCns }}
            </template>
        </rkm-data-table>

        <ModalEstorno ref="ModalEstorno" />
    </div>
</template>

<script>
// Components.
import ModalEstorno from './Modal'

// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    components: { ModalEstorno },
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')
        }
    },
    computed: {

        fields() {

            return [
                {
                    key: 'prontuario',
                    name: 'cadastro_paciente.prontuario',
                    label: 'Prontuário',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nome',
                    name: 'cadastro_cidadao.nome',
                    label: 'Nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nomeMae',
                    name: 'cadastro_cidadao.nome_mae',
                    label: 'Nome da mãe',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataNascimento',
                    name: 'cadastro_cidadao.data_nascimento',
                    label: 'Data de nascimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cns',
                    name: 'cadastro_cidadao.cns',
                    label: 'CNS',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cpf',
                    name: 'cadastro_cidadao.cpf',
                    label: 'CPF',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        open(item) {

            if (item.diasCadastroDesatualizado > 0) {

                const confirm = async () => {

                    this.$refs.ModalEstorno.open(item)

                    return false
                }

                const msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                    dia(s). Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            }

            this.$refs.ModalEstorno.open(item)
        }
    },
    filters: {
        ...formats
    },
    mixins: [repository, error]
}
</script>